import _ from 'lodash'

import {
  LIST_PERMISSIONS_STARTED,
  LIST_PERMISSIONS_COMPLETED,
  LIST_PERMISSIONS_FAILED,
  CLEAR_STATES
} from '@/store/types'
import { marshalPermission } from '@/utils/marshal'
import { hasPermission } from '@/utils/permission'

function getDefaultState () {
  return {
    permissions: undefined,
    init: true,
    loading: false,
    error: undefined
  }
}

export default {
  namespaced: true,
  modules: {},

  state: getDefaultState(),
  getters: {
    canPerform: state => permissionsRequired => {
      return state.init || state.loading || hasPermission(state.permissions, permissionsRequired)
    }
  },

  mutations: {
    [LIST_PERMISSIONS_STARTED] (state) {
      state.loading = true
      state.init = false
    },
    [LIST_PERMISSIONS_COMPLETED] (state, payload) {
      const { permissions = [], isMarshalNeeded } = payload
      if (isMarshalNeeded) {
        state.permissions = _.cloneDeep(permissions.map(marshalPermission))
      } else {
        state.permissions = _.cloneDeep(permissions)
      }
      state.loading = false
      state.error = undefined
    },
    [LIST_PERMISSIONS_FAILED] (state, err) {
      state.loading = false
      state.error = err
    },

    // Clear states
    [CLEAR_STATES] (state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    async list ({ commit, rootState: { client = undefined } }) {
      try {
        commit(LIST_PERMISSIONS_STARTED)
        const permissions = await client.managementClient.listCurrentUserPermissions()
        commit(LIST_PERMISSIONS_COMPLETED, {
          permissions: permissions,
          isMarshalNeeded: true
        })
      } catch (err) {
        console.log(err)
        commit(LIST_PERMISSIONS_FAILED, err)
      }
    }
  }
}
